import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// THUNK
export const getCustomersList = createAsyncThunk(
    'customers/getCustomers',
    async ({ accountId, token, search, start, length, prospect }, { rejectWithValue }) => {
    try {
        // Log per debug paginazione
        console.log('[DEBUG PAGINATION] Parametri richiesta customers:', { accountId, start, length, search, prospect });
        
        // NON APPLICHIAMO PIU' CORREZIONI ALLA PAGINAZIONE LATO FRONTEND
        // Lasciamo che il backend gestisca direttamente i parametri originali
        
        // Costruzione URL
        const url = `${import.meta.env.VITE_API_BASE_URL}/customers/list?accountId=${accountId}&search[value]=${search}&start=${start}&length=${length}&prospect=${prospect}`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const options = { method: 'GET', headers };
        const response = await fetch(url, options);
        if (!response.ok) {
            const error = await response.json();
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        }
        const result = await response.json();
        
        // Log per debug paginazione: risposta API
        console.log('[DEBUG PAGINATION] Risposta API customers:', { 
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            dataCount: result.data ? result.data.length : 0,
            startIndex: start,
            endIndex: start + (result.data ? result.data.length : 0) - 1
        });
        
        return result
    } catch (error) {
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

const customersSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        clearCustomersData: (state) => {
            state.data = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCustomersList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCustomersList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getCustomersList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento di customers list.";
                state.isLoading = false;
            })
    }
});

// Selector
export const selectCustomersData = (state) => state.customers.data;
export const selectCustomersLoading = (state) => state.customers.isLoading;
export const selectCustomersError = (state) => state.customers.error;

export const { clearCustomersData } = customersSlice.actions;
export default customersSlice.reducer;
